// extracted by mini-css-extract-plugin
module.exports = {"androidApp":"AppsStoreIcons__androidApp","iosApp":"AppsStoreIcons__iosApp","linkApp":"AppsStoreIcons__linkApp"};